import { useLocale } from '@app/core/hooks/useLocale';
import {
  OpmFirstLastWaterfallDictionaryDto,
  FirstLastSummaryIndexDictionaryDto,
} from '@app/shared/models/contracts/opm-calculation-results-dto';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import TransactionSummaryRow from '../row-components/TransactionSummaryRow';
import { TrancheLevelRow } from '../row-components/TrancheLevelRow';
import { SubSectionHeader } from '../row-components/SubSectionHeader';

interface InstrumentInterimCashFlowsMinorityDiscountsProps {
  titleColSpan: number;
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedYear: string;
  selectedInstrument: string;
  waterfallIterations: number;
  firstSimulation: string;
  hasInfusions: boolean;
}

const InstrumentInterimCashFlowsMinorityDiscounts: React.FC<
  InstrumentInterimCashFlowsMinorityDiscountsProps
> = ({
  titleColSpan,
  opmWaterfall,
  selectedYear,
  selectedInstrument,
  waterfallIterations,
  firstSimulation,
  hasInfusions,
}: InstrumentInterimCashFlowsMinorityDiscountsProps) => {
  const { l } = useLocale();

  const shouldDisplayDloc = (() => {
    const checkSimulations = (simulations: FirstLastSummaryIndexDictionaryDto) => {
      return Object.values(simulations).some((simulation) => {
        const inst = simulation.instruments[selectedInstrument];
        if (!inst || !inst.tranches) {
          return false;
        }

        return Object.values(inst.tranches).some((tranche) => {
          return tranche.dlocPc != null && tranche.dlocPc !== 0;
        });
      });
    };

    return (
      checkSimulations(opmWaterfall[selectedYear].first as FirstLastSummaryIndexDictionaryDto) ||
      checkSimulations(opmWaterfall[selectedYear].last as FirstLastSummaryIndexDictionaryDto)
    );
  })();

  return (
    <>
      {shouldDisplayDloc && (
        <>
          <SubSectionHeader
            title={l('_MinorityDiscounts')}
            className={styles['sub-section-header']}
            titleColSpan={titleColSpan}
          />
          <TrancheLevelRow
            label="_DLOC"
            valueKey="dlocPc"
            opmWaterfall={opmWaterfall}
            selectedYear={selectedYear}
            firstSimulation={firstSimulation}
            waterfallIterations={waterfallIterations}
            instrumentKey={selectedInstrument}
            isPercentage
          />
          <TrancheLevelRow
            label="_DLOM"
            valueKey="dlomPc"
            opmWaterfall={opmWaterfall}
            selectedYear={selectedYear}
            firstSimulation={firstSimulation}
            waterfallIterations={waterfallIterations}
            instrumentKey={selectedInstrument}
            isPercentage
          />
          <TransactionSummaryRow
            label={
              hasInfusions
                ? '_PostDiscountPvOfOtherInterimCashFlows'
                : '_PostDiscountPVOfInterimCashFlows'
            }
            valueKey="otherCashflowsDiscountedFairValue"
            opmWaterfall={opmWaterfall}
            selectedInstrument={selectedInstrument}
            selectedYear={selectedYear}
            waterfallIterations={waterfallIterations}
            isBold
          />
        </>
      )}
    </>
  );
};

export default InstrumentInterimCashFlowsMinorityDiscounts;
